var map = {
	"./ara.json": "85b6",
	"./chit.json": "4d33",
	"./cmn.json": "96ee",
	"./dan.json": "9a30",
	"./dut.json": "50fc",
	"./eng.json": "9d01",
	"./engu.json": "33a0",
	"./fin.json": "6c97",
	"./fre.json": "f97d",
	"./freu.json": "92a3",
	"./ger.json": "73d4",
	"./hun.json": "1707",
	"./ind.json": "796c",
	"./ita.json": "7514",
	"./jpn.json": "697f",
	"./kor.json": "fc26",
	"./per.json": "07e2",
	"./pol.json": "fca8",
	"./por.json": "86e5",
	"./rus.json": "a99d",
	"./spa.json": "d9cb",
	"./spau.json": "5701",
	"./swe.json": "aeff",
	"./tha.json": "92f2",
	"./tur.json": "6f95",
	"./ukr.json": "cc77",
	"./vie.json": "49fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";